import {HOST, DOMAIN, API_JAVA, UPLOAD, PVER} from '@/utils/base';

export default function (Vue, options) {
    // HOST
    Vue.prototype.vmHost = HOST;
    Vue.prototype.upload = UPLOAD;
    Vue.prototype.pver = PVER;
    //小数位数
    Vue.prototype.mfixed = 2;
    Vue.prototype.wfixed = 3;
    Vue.prototype.pageSize = 20;

    // IframeHost
    Vue.prototype.vmIframeHost = function (HostCurrent) {
        if (process.env.NODE_ENV == 'development') {
            let str = HostCurrent.host;
            return 'http://' + DOMAIN + ':' + str.substring(str.length - 4);
        } else {
            return 'https://' + DOMAIN;
        }
    };

    // 后退
    Vue.prototype.vmGoback = function () {
        if (window.history.length <= 2) {
            this.$router.push({path: this.vmHost});
        } else {
            this.$router.go(-1);
        }
    };

    // 禁止 body 滚动
    Vue.prototype.vmLockOnScroll = function (bool) {
        if (bool) {
            document.body.style.overflowY = 'hidden';
            document.body.style.height = '100vh';
            // document.body.addEventListener('touchmove',function(e) {
            //   e.preventDefault()
            // },true)
        } else {
            document.body.style.overflowY = 'scroll';
            document.body.style.height = 'auto';
            // document.body.removeEventListener('touchmove')
        }
    };

    Vue.prototype.vmBrowser = {
        versions: (function () {
            var u = navigator.userAgent,
                app = navigator.appVersion;
            return {
                //移动终端浏览器版本信息
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            };
        })(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase(),
    };

    Vue.prototype.vmIsWeiXin = function () {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    };

    Vue.prototype.vmIsQQ = function () {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.replace(/QQBrowser/gi, '').match(/QQ/i) == 'qq') {
            //排除了QQ浏览器
            return true;
        } else {
            return false;
        }
    };

    Vue.prototype.vmIsWeiBo = function () {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/WeiBo/i) == 'weibo') {
            return true;
        } else {
            return false;
        }
    };

    Vue.prototype.notify = function (message, type = 1) {
        this.$notify({
            title: '提示',
            message: message ? message : type == 1 ? '处理成功' : '处理失败',
            type: type == 1 ? 'success' : 'error',
        });
    };

    Vue.prototype.goPage = function (url) {
        window.top.IMS_ACTIONS.renderIframe(url);
    };

    Vue.prototype.contractView = function (contractId, id) {
        if (!id) {
            this.notify('请先保存', 0);
            return;
        }
        let c_url = API_JAVA + `/contract/view?id=${contractId}&orderId=${id}`;
        window.open(c_url, '_blank');
    };

    // table - 分页信息
    Vue.prototype.pagination = {
        currentPage: 1,
        pageSize: 20,
    };
}



// WEBPACK FOOTER //
// ./src/utils/prototype.js